<template>
  <a-spin :spinning="loading">
    <div class="center">
      <div class="center_data" >
        <div class="center_tag" ref="centerTag">
          <div :class="index == tabIndex ? 'active' : ''" v-for="(tab, index) in tabs" :key="index" @click="tabClick(index)">{{ tab.typeName }}</div>
        </div>
        <center-success ref="centerSuccess" v-if="tabs.length > 0 && $t(tabs[tabIndex].typeName) == $t('成功案例')"></center-success>
        <center-download ref="centerDownload" v-if="tabs.length > 0 && $t(tabs[tabIndex].typeName) == $t('下载中心')"></center-download>
        <center-type ref="centerType" v-if="tabs.length > 0 && $t(tabs[tabIndex].typeName) != $t('下载中心') && $t(tabs[tabIndex].typeName) != $t('成功案例')"></center-type>
      </div>
    </div>
  </a-spin>
</template>
<script>
import CenterType from './CenterType'
import CenterSuccess from './CenterSuccess'
import CenterDownload from './CenterDownload'
export default {
  components: {
    CenterType,
    CenterSuccess,
    CenterDownload
  },
  data () {
    return {
      loading: false,
      tabIndex: localStorage.getItem('project_centert_tab') || 0,
      programId: this.$route.query.programId,
      tabs: []
    }
  },
  mounted () {
    this.listType()
  },
  methods: {
    tabClick (index) {
      localStorage.setItem('project_centert_tab', index)
      let tab = this.tabs[index]
      this.tabIndex = index
      if (tab.typeName === '成功案例') {
        this.$nextTick(() => {
          this.$refs.centerSuccess.page()
        })
      } else if (tab.typeName === '下载中心') {
        this.$nextTick(() => {
          this.$refs.centerDownload.listDownload()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.centerType.setData(tab.datas, tab.headerBg, tab.headerTop)
        })
      }
    },
    listType () {
      this.loading = true
      this.$api.projectCenter.listType(this.programId).then(res => {
        if (res.status === 0) {
          this.tabs = res.data
          this.tabs.push({ typeName: '成功案例' })
          this.tabs.push({ typeName: '下载中心' })
          this.tabClick(this.tabIndex)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err)
      }).finally(_ => {
        this.loading = false
      })
    }
  },
  watch: {
    '$route.query.programId': {
      handler (newValue, oldValue) {
        if (newValue != this.programId) {
          this.tabIndex = 0
          this.programId = this.$route.query.programId
          this.listType()
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
  .center {
    padding: 20px 0px;
    border-bottom: 1px solid #bfbfbf;
    .center_data {
      .center_tag {
        display: flex;
        align-items: center;
        width: 1200px;
        margin: auto;
        overflow: hidden;
        div {
          padding: 15px 25px;
          color: #484848;
          font-weight: bold;
          font-size: 17px;
          cursor: pointer;
          flex-shrink: 0;
          margin-right: 10px;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
        .active {
          background: #e5e5e5;
        }
        div:hover {
          background: #e5e5e5;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/product/components/CenterTab.vue